/** Id corto para peanas y áreas (único dentro de una escena). */
export const newId = () => crypto.randomUUID().replaceAll('-', '').slice(0, 12);
